import {memo} from 'react'
import {AllowedComponent, IconButtonProps} from './types'
import {Button, Lead} from '@gwc/main'

const IconButton = memo(function IconButton<C extends AllowedComponent = 'button'>({
  children,
  ...props
}: IconButtonProps<C>) {
  return (
    <Button {...props}>
      <Lead>{children}</Lead>
    </Button>
  )
})

export default IconButton
